export const readAuthRole = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem("user") || "null");
    const auth = JSON.parse(localStorage.getItem("authData") || "null");
    const user = stored || auth?.user || null;
    const isAdmin = user?.userType === "admin" || user?.userType === "head";
    return { user, isAdmin };
  } catch {
    return { user: null, isAdmin: false };
  }
};
